import { home, nurse, user } from '~/utils/api.ts';

const model = {
  namespace: 'index',
  state: {
    categorys: [],
    weikeList: [],
    experienceProducts: [],
    bigProducts: [],
    recommendations: [],
    loading: false,
  },
  reducers: {
    init(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
  effects: {
    *getStatic({ payload }, { call, put }) {
      const resp = yield call(home.getStatic, payload);
      if (resp.status === 0) {
        const weikeList = resp.pc_index_weikes;
        yield put({
          type: 'init',
          payload: {
            weikeList,
          },
        });
      }
    },
    *getSku(_, { call, put, select }) {
      const cityCode = yield select(state => state.city.currentCity.id);
      const resp = yield call(home.getSku, { city_code: cityCode });
      if (resp.status === 0) {
        const experienceProducts = resp.experience_products || [];
        const bigProducts = resp.big_products || [];
        const categorys = resp.pc_index_categorys || [];
        yield put({
          type: 'init',
          payload: {
            experienceProducts,
            bigProducts,
            categorys,
          },
        });
      }
    },
    *getYuesaoRecommendations({ payload }, { call, put }) {
      yield put({
        type: 'init',
        payload: {
          loading: true,
        },
      });
      try {
        payload = payload || {};
        payload.per_page = 24;
        const resp = yield call(nurse.getYuesaoRecommendations, { ...payload });
        if (resp.status === 0) {
          const recommendations = resp.data.items || [];
          yield put({
            type: 'init',
            payload: {
              recommendations,
              loading: false,
            },
          });
        } else {
          yield put({
            type: 'init',
            payload: {
              loading: false,
            },
          });
        }
      } catch (error) {
        yield put({
          type: 'init',
          payload: {
            loading: false,
          },
        });
      }
    },
    *submitLeadForm({ payload }, { call }) {
      const resp = yield call(user.submitPhoneInquiry, payload);
      console.log('submitLeadForm response:', resp);
    },
  },
};

export default model;
